import { format } from 'libs';

interface CurrentCardProps {
  user: {
    pm_last_four?: string;
    pm_type?: string;
  };
}

const CurrentCard = ({ user }: CurrentCardProps) => (
  <div className="d-flex flex-wrap align-items-center mb-2">
    <span className="fw-bold me-2">Current card:</span>
    <div>
      <span className="me-2">{format.cardBrand(user.pm_type!)}</span>
      <span data-testid="subscriptions-last-used-card-number">**** **** **** {user.pm_last_four || '****'}</span>
    </div>
  </div>
);

export default CurrentCard;
